import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ErrorRecoveryPanel = ({ alerts, onRecoveryAction }) => {
  const [expandedAlert, setExpandedAlert] = useState(null);

  const recoveryOptions = [
    {
      id: 'token-refresh',
      title: 'Atualizar Tokens',
      description: 'Renovar tokens de autenticação expirados',
      icon: 'RefreshCw',
      action: () => {
        alert('Atualização de tokens em desenvolvimento');
      }
    },
    {
      id: 'connection-reset',
      title: 'Resetar Conexões',
      description: 'Reiniciar todas as conexões de API',
      icon: 'RotateCcw',
      action: () => {
        alert('Reset de conexões em desenvolvimento');
      }
    },
    {
      id: 'queue-clear',
      title: 'Limpar Filas',
      description: 'Remover operações pendentes travadas',
      icon: 'Trash2',
      action: () => {
        alert('Limpeza de filas em desenvolvimento');
      }
    },
    {
      id: 'cache-clear',
      title: 'Limpar Cache',
      description: 'Remover dados em cache corrompidos',
      icon: 'Database',
      action: () => {
        localStorage.clear();
        alert('Cache limpo com sucesso! Recarregue a página.');
      }
    }
  ];

  const diagnosticInfo = [
    { label: 'Uptime do Sistema', value: '99.8%', status: 'success' },
    { label: 'Latência Média', value: '245ms', status: 'success' },
    { label: 'Requisições/min', value: '127', status: 'success' },
    { label: 'Taxa de Erro', value: '0.2%', status: 'success' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 space-y-4">
      <div className="flex items-center gap-3">
        <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-primary/10">
          <Icon name="Wrench" size={24} color="var(--color-primary)" />
        </div>
        <div>
          <h3 className="font-semibold text-foreground">Recuperação de Erros</h3>
          <p className="text-xs text-muted-foreground">Ações rápidas e diagnósticos</p>
        </div>
      </div>

      {/* Quick Recovery Actions */}
      <div className="space-y-2">
        <h4 className="text-sm font-medium text-foreground mb-2">Ações Rápidas</h4>
        <div className="grid grid-cols-2 gap-2">
          {recoveryOptions?.map((option) => (
            <button
              key={option?.id}
              onClick={option?.action}
              className="p-3 rounded-lg bg-muted/30 hover:bg-muted/50 border border-border transition-smooth text-left"
            >
              <div className="flex items-center gap-2 mb-1">
                <Icon name={option?.icon} size={16} className="text-primary" />
                <span className="text-sm font-medium text-foreground">{option?.title}</span>
              </div>
              <p className="text-xs text-muted-foreground">{option?.description}</p>
            </button>
          ))}
        </div>
      </div>

      {/* Diagnostic Information */}
      <div className="space-y-2">
        <h4 className="text-sm font-medium text-foreground mb-2">Informações de Diagnóstico</h4>
        <div className="grid grid-cols-2 gap-2">
          {diagnosticInfo?.map((info, index) => (
            <div key={index} className="p-3 rounded-lg bg-muted/30">
              <p className="text-xs text-muted-foreground mb-1">{info?.label}</p>
              <div className="flex items-center gap-2">
                <p className="text-sm font-semibold text-foreground">{info?.value}</p>
                <div 
                  className="w-2 h-2 rounded-full"
                  style={{ backgroundColor: `var(--color-${info?.status})` }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Alert-Specific Recovery */}
      {alerts && alerts?.length > 0 && (
        <div className="space-y-2">
          <h4 className="text-sm font-medium text-foreground mb-2">Recuperação por Alerta</h4>
          {alerts?.slice(0, 3)?.map((alert) => (
            <div 
              key={alert?.id}
              className="p-3 rounded-lg bg-muted/30 border border-border"
            >
              <div className="flex items-center justify-between">
                <p className="text-sm font-medium text-foreground">{alert?.title}</p>
                {alert?.recoveryAction && (
                  <Button
                    variant="outline"
                    size="sm"
                    iconName="Play"
                    iconPosition="left"
                    onClick={() => onRecoveryAction?.(alert?.recoveryAction)}
                  >
                    Resolver
                  </Button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ErrorRecoveryPanel;